// format utc date to query string format in user's locale/timezone
// e.g. 2025-04-27T12:00
export function getLocaleISOString(dateString) {
  try {
    const date = new Date(dateString);
    if (date instanceof Date && !isNaN(date)) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  } catch (error) {
    console.error('Error formatting date', error);
  }

  return '';
}
